import { BreakpointObserver } from '@angular/cdk/layout'
import { Component } from '@angular/core'
import { Subscription } from 'rxjs'
import { AccordionEmissionService } from 'src/app/services/accordionEmission/accordionEmission.service'
import { AdobeLaunchService } from 'src/server/adobe-launch/adobe-launch.service'

import { PriceTabService } from './price.service'

@Component({
  selector: 'price',
  templateUrl: './price.component.html',
  styleUrls: ['./price.component.scss'],
})
export class PriceComponent {
  priceSubscription: Subscription
  premiumDiscountSubscription: Subscription
  priceModel: any
  premiumDiscountModel: any
  fundAnalyticsModel: any
  fundAnalyticsSubscription: Subscription

  historicalPriceModel: any
  historicalPriceSubscription: Subscription
  historical = ['1M', '3M', '6M', '1Y', '3Y', '5Y', '10Y']
  nvgETFHistorical = ['3Y', '5Y', '10Y']
  allPrice: object[]

  isLargeScreen: boolean

  constructor(
    private readonly priceService: PriceTabService,
    public adobeLaunchService: AdobeLaunchService,
    private breakpointObserver: BreakpointObserver,
    private accordionEmissionService: AccordionEmissionService,
  ) {}

  public stateChangeHandler(accordions: Array<{ isExpanded: true }>) {
    if (accordions[0].isExpanded)
      this.accordionEmissionService.emitAccordionOpened()
  }

  ngOnInit() {
    this.callRefresh(true)

    this.breakpointObserver
      .observe(['(max-width: 576px)', '(max-width: 992px)'])
      .subscribe((result) => {
        this.isLargeScreen = result.breakpoints['(max-width: 992px)']
      })
  }
  callRefresh(manual) {
    /* istanbul ignore next */
    this.priceService.priceModel = undefined
    this.priceService.premiumDiscountModel = {}

    this.priceSubscription = this.priceService
      .getModelData()
      .subscribe((model) => {
        this.priceModel = model
        this.gethistoricalInfo()
      })

    if (manual) {
      this.premiumDiscountSubscription = this.priceService
        .getPremiumData()
        .subscribe((model) => {
          this.premiumDiscountModel = model
        })

      this.fundAnalyticsSubscription = this.priceService
        .getFundAnalytics()
        .subscribe((model) => {
          this.fundAnalyticsModel = model
        })
    }
  }

  // eslint-disable-next-line complexity, max-statements
  dateRange(elemantlabel: string) {
    let label = ''
    if (elemantlabel === '1M') {
      label = '1 month'
    } else if (elemantlabel === '3M') {
      label = '3 months'
    } else if (elemantlabel === '6M') {
      label = '6 months'
    } else if (elemantlabel === '1Y') {
      label = '1 year'
    } else if (elemantlabel === '3Y') {
      label = '3 years'
    } else if (elemantlabel === '5Y') {
      label = '5 years'
    } else if (elemantlabel === '10Y') {
      label = '10 years'
    }
    return label
  }

  gethistoricalInfo() {
    this.allPrice = []
    const historicalArray =
      this.priceModel?.profile?.isExternalFund &&
      this.priceModel?.profile?.isETF
        ? this.nvgETFHistorical
        : this.historical
    historicalArray.forEach((element) => {
      const label = this.dateRange(element)
      this.allPrice.push({ label, element })
    })
  }

  ngOnDestroy(): void {
    this.priceSubscription.unsubscribe()
    this.premiumDiscountSubscription.unsubscribe()
    this.fundAnalyticsSubscription.unsubscribe()
  }

  toggleAccordian(ev): void {
    if (ev === true) {
      this.adobeLaunchService.subPageTabEvent(
        `${this.priceModel?.profile?.ticker}:price:Accordian`,
      )
    }
  }
}
